import {
  OPEN_WELLNESS_COMPANION,
  CREATE_HEALTH_KEEPER_ACCOUNT,
  FETCH_HEALTH_KEEPER_TOKEN,
  SHOW_CREATE_HEALTH_KEEPER_ACCOUNT_DIALOG,
} from '../actions/healthKeeperAction';
import { put, select, takeLatest, call } from 'redux-saga/effects';
import { getHealthKeeperRevampLinkUrl } from '../selectors/configSelectors';
import {
  getHealthKeeperToken,
  postHealthKeeperCreateAccountAPI,
} from '../services/healthKeeperService';
import {
  GET_HEALTH_KEEPER_TOKEN_SUCCESS,
  GET_HEALTH_KEEPER_TOKEN_SUCCESS_CACHE,
  GET_HEALTH_KEEPER_TOKEN_NEW_USER,
  GET_HEALTH_KEEPER_TOKEN_FAIL,
  CREATE_USER_SUCCESS,
  CREATE_USER_API_ERROR,
} from '../services/healthKeeperService';
import { joinPath, getBaseUrl } from '../../../utils';

let newWindow: any;

function* openWellnessCompanion(action: any): any {
  const result = yield getHealthKeeperToken({});
  switch (result.type) {
    case GET_HEALTH_KEEPER_TOKEN_SUCCESS:
    case GET_HEALTH_KEEPER_TOKEN_SUCCESS_CACHE:
      let url = yield select(getHealthKeeperRevampLinkUrl);
      url = url.replace('${endUserJwt}', result.token);
      const thisWidow = window.open(url, '_blank');
      if (!thisWidow && newWindow) {
        newWindow.location.href = url;
      }
      break;
    case GET_HEALTH_KEEPER_TOKEN_NEW_USER:
      newWindow && newWindow.close();
      //show registration page.
      yield put({ type: SHOW_CREATE_HEALTH_KEEPER_ACCOUNT_DIALOG });
      break;
    case GET_HEALTH_KEEPER_TOKEN_FAIL:
      newWindow && newWindow.close();
      // todo: show some error message if it's not accessable
      yield put({ type: SHOW_CREATE_HEALTH_KEEPER_ACCOUNT_DIALOG });
      break;
  }
}

function* createHealthKeeperAccount(): any {
  const absUrl = joinPath(
    getBaseUrl(),
    'home/healthkeeper/wellness-companion-redirect',
  );
  newWindow = absUrl && window.open(absUrl, '_blank');
  const createAccountResult = yield postHealthKeeperCreateAccountAPI();
  if (createAccountResult.type == CREATE_USER_SUCCESS) {
    yield put({ type: OPEN_WELLNESS_COMPANION });
  } else {
    newWindow && newWindow.close();
  }
}

function* fetchHealthKeeperToken(): any {
  const result = yield getHealthKeeperToken({});
  if (result.type == GET_HEALTH_KEEPER_TOKEN_SUCCESS) {
    // update Company Code if user exist
    yield postHealthKeeperCreateAccountAPI();
  }
}

function* healthKeeperSaga(): any {
  yield takeLatest(OPEN_WELLNESS_COMPANION, openWellnessCompanion);
  yield takeLatest(CREATE_HEALTH_KEEPER_ACCOUNT, createHealthKeeperAccount);
  yield takeLatest(FETCH_HEALTH_KEEPER_TOKEN, fetchHealthKeeperToken);
}

export default healthKeeperSaga;
